import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { UPDATE_USER_PREFERENCE } from 'src/app/modules/users/queries/user.queries';
import {
  MutationResult,
  UpdateResult,
} from 'src/app/shared/graph-queries/types';

@Injectable({
  providedIn: 'root',
})
export class UserPreferenceService {
  constructor(private apollo: Apollo) {}

  save(azureOid: string, value: any): Observable<MutationResult> {
    return this.apollo.mutate<UpdateResult>({
      mutation: UPDATE_USER_PREFERENCE,
      variables: {
        id: azureOid,
        payload: JSON.stringify(value),
      },
    });
  }
}
